<template>
  <div class="selectagentView">
    <el-dialog :title="agenttitle" center :visible.sync="dlrdialogVisible" class="selectagentView" width="45%"
      append-to-body>
      <div class="selectagentViewcontent">
        <div class="agentform">
          <el-form :inline="true" :model="form" class="demo-form-inline" label-width="auto">
            <el-form-item label="姓名: ">
              <el-input class="agentipt" v-model="form.realname"></el-input>
            </el-form-item>
            <el-form-item label="电话: ">
              <el-input class="agentipt" v-model="form.mobile"></el-input>
            </el-form-item>
            <div class="btn">
              <ccBtn @search="search" @reset="reset"></ccBtn>
            </div>
          </el-form>

        </div>
        <div class="table">
          <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark"
            :header-cell-style="{ background: '#F1F8FF ', borderBottom: '1px solid #3D3D3D', color: '#000' }"
            @current-change="radiochange">
            <el-table-column align="center" width="60">
              <template slot-scope="scope">
                <el-radio class="radio" :label="scope.row" v-model="currentRow">{{ "" }}</el-radio>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="realname" label="姓名">
            </el-table-column>
            <!-- <el-table-column align="center" prop="mobile" label="代理人电话">
            </el-table-column> -->
            <el-table-column align="center" prop="name" label="代理者">
            </el-table-column>
            <!-- <el-table-column align="center" prop="adress" label="联系地址">
            </el-table-column> -->
            <el-table-column align="center" label="目前状态">
              <template slot-scope="scope">
                <el-tag type="primary" v-if="scope.row.status == '1'">待签约</el-tag>
                <el-tag type="success" v-else>已签约</el-tag>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="remark" label="备注">
            </el-table-column>
          </el-table>
        </div>
        <paginaTion :current-page="form.page" :total="total" @current-change="handleCurrentChange" />
      </div>
      <div slot="footer" class="footerbtn">
        <el-button type="primary" @click="config">确 定</el-button>
        <el-button @click="dlrdialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { getdlrlistApi } from '@/Api/agentapi';
export default {
  name: "selectagentView",
  props: {
    agenttitle: {
      type: String,
      default: '选择代理人'
    }
  },
  data() {
    return {
      dlrdialogVisible: false,
      //表格加载状态
      tableloading: false,
      form: {
        realname: '',
        mobile: '',
        page: 1
      },
      // 列表总数
      total: 0,
      tableData: [],
      currentRow: null
    };
  },
  created() {
    this.getdlrlist()
  },
  methods: {
    // 获取代理人列表
    async getdlrlist() {
      let res = await getdlrlistApi(this.form)
      this.tableloading = true
      if (res.code == 0) {
        this.tableData = res.data.data
        this.total = res.data.total
        this.tableloading = false
      }
    },
    show() {
      this.dlrdialogVisible = true;
    },

    config() {
      if (this.currentRow) {
        this.$emit('config', this.currentRow)
        this.dlrdialogVisible = false
      } else {
        this.$message.warning('请选择代理人');
      }
    },
    search() {
      this.getdlrlist()
    },
    reset() {
      this.resetForm(this.form)
      this.getdlrlist()

    },
    radiochange(row) {
      this.currentRow = row;
    },
    handleSizeChange(val) {
      this.form.page.pageSize = val;
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.getdlrlist()
    }
  }

};
</script>

<style lang="scss">
.selectagentView {
  .el-dialog {
    background-color: #f5f5f5;
  }

  .el-dialog__footer {
    border-top: 1px solid #e3e4e6;
  }

  .el-dialog__body {
    padding: 20px;
  }
}

.selectagentViewcontent {
  padding: 20px;
  background: #FFFFFF;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.25);
  border-radius: 8px;

  .agentform {
    .demo-form-inline {
      display: flex;

      .agentipt {
        width: 150px;
      }
    }
  }
}

.footerbtn {
  display: flex;
  justify-content: flex-end;
}
</style>